"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var toggle_1 = __importDefault(require("relements/build/esm/input/toggle"));
var text_1 = __importDefault(require("relements/build/esm/input/text"));
var utils_1 = require("@src/utils");
var const_1 = require("./const");
var ENABLE_COMMERCE_PLUS = const_1.COMMERCE_PLUS.ENABLE_COMMERCE_PLUS, BOT_NAME = const_1.COMMERCE_PLUS.BOT_NAME, ENABLE_OVERRIDING_STAGING_URL = const_1.COMMERCE_PLUS.ENABLE_OVERRIDING_STAGING_URL, OVERRIDING_STAGING_URL = const_1.COMMERCE_PLUS.OVERRIDING_STAGING_URL;
var CommercePlusInputs = {
    title: '',
    inputs: [
        {
            label: 'Enable Commerce+',
            key: 'enableCommercePlus',
            component: toggle_1["default"],
            props: function (data, onChange) {
                return {
                    disabled: utils_1.isProduction(),
                    tooltip: 'Toggle to activate C+ bot for this client.',
                    value: data[ENABLE_COMMERCE_PLUS],
                    onChange: function (value) { return onChange(ENABLE_COMMERCE_PLUS, value); },
                };
            },
        },
        {
            label: 'Bot Name*',
            key: 'botName',
            component: text_1["default"],
            props: function (data, onChange) {
                return {
                    tooltip: '',
                    disabled: !data[ENABLE_COMMERCE_PLUS] || utils_1.isProduction(),
                    value: data[BOT_NAME],
                    onChange: function (value) { return onChange(BOT_NAME, value.trim()); },
                    placeholder: 'Enter name of commerce+ bot',
                };
            },
        },
        {
            label: 'Overriding Staging URL',
            key: 'enableOverridingStagingURL',
            component: toggle_1["default"],
            props: function (data, onChange) {
                return {
                    tooltip: 'If you want to point Haptik staging to a dev URL, enable this override, and add relevant C+ URL ',
                    disabled: !data[ENABLE_COMMERCE_PLUS] || utils_1.isProduction(),
                    value: data[ENABLE_OVERRIDING_STAGING_URL],
                    onChange: function (value) {
                        return onChange(ENABLE_OVERRIDING_STAGING_URL, value);
                    },
                };
            },
        },
        {
            label: '',
            key: 'overridingStagingURL',
            component: text_1["default"],
            props: function (data, onChange) {
                return {
                    tooltip: '',
                    disabled: !data[ENABLE_COMMERCE_PLUS] ||
                        !data[ENABLE_OVERRIDING_STAGING_URL] ||
                        utils_1.isProduction(),
                    value: data[OVERRIDING_STAGING_URL],
                    onChange: function (value) {
                        return onChange(OVERRIDING_STAGING_URL, value.trim());
                    },
                    placeholder: 'Enter commerce+ bot url',
                };
            },
        },
    ],
};
exports["default"] = CommercePlusInputs;
